<template>
  <!--
    Tile image for a media file from moduleMediaFile. The original (`src`) is
    ~5MB, so a tile never asks for it while a thumbnail may still arrive:

      thumb set                     -> thumb
      no thumb, not resolved yet    -> placeholder
      no thumb, resolved            -> src (no thumbnail could be made)

    Lightboxes, printing and document embedding use `src` directly, not this.
  -->
  <div
    v-if="!url"
    class="media-thumb-placeholder"
    role="img"
    :aria-label="$attrs.alt"
    v-on="$listeners"
  >
    <b-spinner v-if="pending" small variant="secondary" />
  </div>
  <b-img
    v-else
    v-bind="$attrs"
    :src="url"
    loading="lazy"
    decoding="async"
    v-on="$listeners"
    @error="onError"
  />
</template>

<script>
export default {
  name: "MediaThumb",
  inheritAttrs: false,
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    pending() {
      // Objects built outside the store have no flag: treat as resolved.
      return !this.item.thumb && this.item.thumbResolved === false;
    },
    url() {
      if (this.item.thumb) return this.item.thumb;
      if (this.pending) return null;
      return this.item.src || null;
    }
  },
  methods: {
    onError() {
      // An expired presign (a list cached past 15 minutes) or a missing S3
      // object. Fall back to the original; if that fails too, stop there.
      if (this.item.thumb && this.url === this.item.thumb) {
        this.$store.commit("moduleMediaFile/dropThumbnail", this.item);
      }
    }
  }
};
</script>

<style scoped>
/* No width: as a block it fills the tile, and fixed-size tiles (FileManage)
   size it through their own class without a specificity fight. */
.media-thumb-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 4 / 3;
  min-height: 60px;
  background-color: #f1f3f5;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
}
</style>
